import { Cloudinary } from "@cloudinary/url-gen";
import { format } from "@cloudinary/url-gen/actions/delivery";

// Create Cloudinary instance
const cld = new Cloudinary({
  cloud: {
    cloudName: "dci1aiukm",
  },
});

// Gallery images data with proper alt text for CSR Project Shiksha - All images from Cloudinary folder
const galleryImagesData = [
  {
    name: "20240115_004221570_iOS",
    alt: "Project Shiksha - Students in classroom learning session",
  },
  {
    name: "20240115_014425880_iOS",
    alt: "Project Shiksha - Educational materials and resources",
  },
  {
    name: "CSR-1",
    alt: "Project Shiksha - School infrastructure development",
  },
  {
    name: "CSR-2",
    alt: "Project Shiksha - Children participating in educational activities",
  },
  {
    name: "20240128_011448660_iOS",
    alt: "Project Shiksha - Community engagement and learning",
  },
  {
    name: "20240128_012107110_iOS",
    alt: "Project Shiksha - Educational support program",
  },
  {
    name: "20240128_012344080_iOS",
    alt: "Project Shiksha - Students with learning materials",
  },
  {
    name: "20240128_055440370_iOS",
    alt: "Project Shiksha - Educational initiative documentation",
  },
  {
    name: "20240128_061945050_iOS",
    alt: "Project Shiksha - School building and facilities",
  },
  {
    name: "20240128_063535550_iOS",
    alt: "Project Shiksha - Educational outreach program",
  },
  {
    name: "20240303_015544670_iOS",
    alt: "Project Shiksha - Children's educational development",
  },
  {
    name: "20240312_003051480_iOS",
    alt: "Project Shiksha - Community education initiative",
  },
  {
    name: "20240324_224316160_iOS",
    alt: "Project Shiksha - Learning environment enhancement",
  },
  {
    name: "20240324_224724460_iOS",
    alt: "Project Shiksha - Educational support and mentoring",
  },
  {
    name: "20240402_225749960_iOS",
    alt: "Project Shiksha - Students engaged in learning activities",
  },
  {
    name: "20240402_230557670_iOS",
    alt: "Project Shiksha - Educational resources distribution",
  },
  {
    name: "20240402_230705100_iOS",
    alt: "Project Shiksha - Community learning program",
  },
  {
    name: "20240402_231025460_iOS",
    alt: "Project Shiksha - Student development activities",
  },
  {
    name: "20240527_022244410_iOS",
    alt: "Project Shiksha - Educational workshop session",
  },
  {
    name: "20240527_022450310_iOS",
    alt: "Project Shiksha - Learning materials preparation",
  },
  {
    name: "20240529_013832630_iOS",
    alt: "Project Shiksha - School community engagement",
  },
  {
    name: "20240603_025140480_iOS",
    alt: "Project Shiksha - Educational support initiative",
  },
  {
    name: "20240603_025232550_iOS",
    alt: "Project Shiksha - Children's learning program",
  },
  {
    name: "20240603_034656990_iOS",
    alt: "Project Shiksha - Educational development project",
  },
  {
    name: "20240603_040649170_iOS",
    alt: "Project Shiksha - Student mentoring session",
  },
  {
    name: "20240820_071739000_iOS",
    alt: "Project Shiksha - Community education outreach",
  },
  {
    name: "20240820_071912000_iOS",
    alt: "Project Shiksha - Learning environment setup",
  },
  {
    name: "20241013_005253450_iOS",
    alt: "Project Shiksha - Educational materials distribution",
  },
  {
    name: "20241013_005658520_iOS",
    alt: "Project Shiksha - Student engagement activities",
  },
  {
    name: "20241013_011747490_iOS",
    alt: "Project Shiksha - School infrastructure support",
  },
  {
    name: "CSR-5",
    alt: "Project Shiksha - Educational program implementation",
  },
  {
    name: "20241024_002948040_iOS",
    alt: "Project Shiksha - Community learning initiative",
  },
  {
    name: "CSR-3",
    alt: "Project Shiksha - Student development program",
  },
  {
    name: "20241209_055542130_iOS",
    alt: "Project Shiksha - Educational support activities",
  },
  {
    name: "20241221_053401297_iOS",
    alt: "Project Shiksha - Learning resources provision",
  },
  {
    name: "20250109_061228603_iOS",
    alt: "Project Shiksha - School community program",
  },
  {
    name: "20251127_094125031_iOS",
    alt: "Project Shiksha - Educational initiative documentation",
  },
];

// Function to generate Cloudinary image objects
export const getGalleryImages = () => {
  return galleryImagesData.map((imageData, index) => ({
    imageName: imageData.name,
    cloudinaryImage: cld
      .image(imageData.name)
      .quality("auto")
      .delivery(format("webp")),
    alt: imageData.alt,
    id: index + 1,
  }));
};

// Export the gallery images
export const galleryImages = getGalleryImages();
